function DNDDescription({ card, language, elementStyle, changeSelection }) {
  function convertText(text) {
    var elements = [];
    var counter = 1;
    while (
      checkForUrl(text, "LINK") ||
      checkForUrl(text, "MAIL") ||
      checkForUrl(text, "TEXT")
    ) {
      const urlEl = text.indexOf("$LINK[");
      const mailEl = text.indexOf("$MAIL[");
      const textEl = text.indexOf("$TEXT[");
      var variante = "LINK";
      if (
        (urlEl === -1 || (mailEl !== -1 && mailEl < urlEl)) &&
        (textEl === -1 || (mailEl !== -1 && mailEl < textEl))
      ) {
        variante = "MAIL";
      } else if (urlEl === -1 || (textEl !== -1 && textEl < urlEl)) {
        variante = "TEXT";
      }

      elements.push(text.substring(0, text.indexOf("$" + variante + "[")));
      var linkOptions = text.substring(
        text.indexOf("$" + variante + "[") + 6,
        text.indexOf("]", text.indexOf("$" + variante + "["))
      );

      /*
                0 ... url
                1 ... descriptions
                2 ... color
            */
      linkOptions = linkOptions.split(";");

      if (variante === "TEXT") {
        elements.push(
          <div
            style={{
              display: "inline-block",
              color: linkOptions[2] || "black",
              fontFamily: linkOptions[0] === "true" ? "Open Sans Bold" : "Open Sans",
              whiteSpace: "nowrap",
            }}
          >
            {linkOptions[1]}
          </div>
        );
      } else {
        elements.push(
          <a
            key={"link_" + counter++}
            href={
              variante === "MAIL" ? "mailto:" + linkOptions[0] + "?subject=" + linkOptions[3] + "&body=" + linkOptions[4] : linkOptions[0]
            }
            style={{
              color: linkOptions[2] || "black",
              textDecoration: "underline",
              whiteSpace: "nowrap",
            }}
            target="_blank"
            rel="noreferrer"
          >
            {linkOptions[1] || linkOptions[0]}
          </a>
        );
      }

      text = text.slice(
        text.indexOf("]", text.indexOf("$" + variante + "[")) + 1
      );
    }

    elements.push(text);

    return <div>{elements}</div>;
  }

  function checkForUrl(text, variante) {
    if (
      text.indexOf("$" + variante + "[") !== -1 &&
      text.indexOf("]", text.indexOf("$" + variante + "[")) !== -1 &&
      text.indexOf("$" + variante + "[") <
        text.indexOf("]", text.indexOf("$" + variante + "["))
    ) {
      return true;
    }

    return false;
  }

  return (
    <div
      id="componentContainer"
      data-tour="rpdesigner-step-3"
      style={elementStyle}
      onClick={changeSelection}
    >
      {convertText(card?.value[0]?.languages[language] || "")}
      <input
        readOnly
        id="displayDefault"
        style={{ display: "none" }}
        value={card.displayDefault}
      />
      <input
        readOnly
        id="displaySuccess"
        style={{ display: "none" }}
        value={card.displaySuccess}
      />
      <input
        readOnly
        id="displayError"
        style={{ display: "none" }}
        value={card.displayError}
      />
    </div>
  );
}

export default DNDDescription;
